/** @format */

import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Chain } from '@shared/data-access/interfaces';
import { noContentErrorMessages } from './no-content-error-messages.constants';

@Component({
  selector: 'home-no-content',
  templateUrl: './no-content.component.html',
  styleUrl: './no-content.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NoContentComponent implements OnInit {
  @Input() chain: Chain;
  errorMessageConfig: any;
  ERROR_MESSAGES = noContentErrorMessages;
  ngOnInit() {
    this.errorMessageConfig =
      this.ERROR_MESSAGES[this.chain.chainIdentifierAbbr] || this.ERROR_MESSAGES['dsg']; // default to dickssportinggoods if chainValue is not matched
  }
}
